import StorageHelper from "../helpers/StorageHelper";
const storageHelper = new StorageHelper();

export class SiafLiteApiAI {
  constructor(url) {
    this.url = url;
    const localStorageToken = storageHelper.getLocal("token");
    this.authorization = `Bearer ${localStorageToken}`;
  }

  async get(filter) {
    let urlGet = this.url;
    if (filter) {
      urlGet = gerarUrlComFiltro(this.url, filter);
    }
    const response = await fetch(urlGet, {
      method: "GET",
      headers: {
        Authorization: this.authorization,
      },
    });
    return await response.json();
  }

  async post(body) {
    const response = await fetch(this.url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: this.authorization,
      },
      body: JSON.stringify(body),
    });
    return await response.json();
  }

  async put(id, body) {
    let urlPut = `${this.url}/${id}`;
    const response = await fetch(urlPut, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
        Authorization: this.authorization,
      },
      body: JSON.stringify(body),
    });
    return await response.json();
  }

  async patch(body) {
    const response = await fetch(this.url, {
      method: "PATCH",
      headers: {
        "Content-Type": "application/json",
        Authorization: this.authorization,
      },
      body: JSON.stringify(body),
    });
    return await response.json();
  }

  async postStream(body) {
    const response = await fetch(this.url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: this.authorization,
        Accept: "text/event-stream",
      },
      body: JSON.stringify(body),
    });

    if (!response.ok || !response.body) {
      throw new Error(`Stream error: ${response.status}`);
    }
    return parseSseStream(response.body);
  }
}

function gerarUrlComFiltro(url, filter) {
  let filtroString = "";
  for (const key in filter) {
    if (filter[key]) {
      const parametroFilro = filter[key]?.toString().replaceAll(/\s/g, "+");
      if (filtroString) {
        filtroString += `&${key}=${parametroFilro}`;
      } else {
        filtroString += `${key}=${parametroFilro}`;
      }
    }
  }
  return `${url}?${filtroString}`;
}

async function* parseSseStream(body) {
  const reader = body.getReader();
  const decoder = new TextDecoder();
  let buffer = "";

  try {
    while (true) {
      const { done, value } = await reader.read();
      if (done) break;

      buffer += decoder.decode(value, { stream: true });
      const parts = buffer.split("\n\n");
      buffer = parts.pop();

      for (const part of parts) {
        if (!part.trim()) continue;

        let eventName = "message";
        let dataLine = "";

        for (const line of part.split("\n")) {
          if (line.startsWith("event:")) {
            eventName = line.slice(6).trim();
          } else if (line.startsWith("data:")) {
            dataLine = line.slice(5).trim();
          }
        }
        let data = dataLine;
        if (dataLine && dataLine !== "[DONE]") {
          try {
            data = JSON.parse(dataLine);
          } catch {
            data = dataLine;
          }
        }

        yield { event: eventName, data };
      }
    }
  } finally {
    reader.releaseLock();
  }
}
